"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Creates a back href to the page one level higher in the site's hierarchy.
 * @param {*} path The URL of the current page.
 * @returns {url: string, title: string} An object containing the URL and the title
 * of the page.
 */
var goBack = function goBack(path) {
  var url = path.split("/");
  url.pop();
  return {
    url: url.join("/"),
    title: url[url.length - 1].replace("-", " ")
  };
};

var _default = goBack;
exports["default"] = _default;